import styles from "./Graph.module.css"
import graph_image from "../../../images/graph.png"

const Graph = () => {
  return (
      <div className={styles.graph_container}>
          {/* <div className={styles.graph_header}>THIS IS THE GRAP HEADER</div> */}
          <img src={graph_image} alt="example graph" />
          
    </div>
  )
}

export default Graph